import { useLocation } from "react-router-dom";

const noSidebarPaths = [
  "/",
  "/Guest",
  "/GuestCheckout",
  "/Login",
  "/CashReceipt",
  "/CashReceiptA4",
  "/ModuleTransfer",
];

const HideSidebar = () => {
  const location = useLocation();

  // Extract the path without query parameters
  const pathWithoutQuery = location.pathname;

  // Check if the path matches without query parameters
  if (noSidebarPaths.includes(pathWithoutQuery)) {
    return true;
  }

  // Additional check for specific query parameter conditions
  if (pathWithoutQuery === "/Paymentdetails") {
    const queryParams = new URLSearchParams(location.search);
    const paymentId = queryParams.get("paymentId");
    const actionText = queryParams.get("actionText");

    if (paymentId && actionText) {
      return true; // Hide sidebar for Paymentdetails with valid query params
    }
  }

  return false; // Show sidebar for all other cases
};

export default HideSidebar;
